<template>
  <div>
    <div
      v-for="(step, index) in steps"
      :key="step.id"
      class="mb-6"
    >
      <div class="fw-600 fs-18 mb-2">{{ index + 1 }}. {{ $bct(step.title) }}</div>
      <MarkdownContent
        :content="step.description"
        class="fs-16 mb-2"
      />

      <div
        v-for="att in step.meta.attachments"
        :key="att.id"
      >
        <a
          v-text="att.file.metadata.filename"
          :href="att.url"
          class="c-primary fs-14 underlined"
          target="_blank"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import MarkdownContent from '@/shared/components/MarkdownContent.vue';

const $bct = inject('translator');

defineProps({
  steps: {
    type: Array,
    default: null,
  },
});
</script>
